import { render, staticRenderFns } from "./a-svg-logo.vue?vue&type=template&id=0c9dc9d2"
import script from "./a-svg-logo.vue?vue&type=script&lang=js"
export * from "./a-svg-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports